import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WoActivePopupComponent } from '../../../popups/wo-active-popup/wo-active-popup.component';
import { ShowWoPopupComponent } from '../../../popups/show-wo-popup/show-wo-popup.component';
import { CommonService } from '../../../../services/common.service';

@Component({
  selector: 'ers-cases',
  templateUrl: './ers-cases.component.html',
  styleUrls: ['./ers-cases.component.scss']
})
export class ErsCasesComponent implements OnInit {

  @Input() roDetailsCount: any;

  RODetailsData = {
    pending: 0,
    enRoute: 0,
    onSite: 0,
    waitingEst: 0,
    waitingClientApp: 0
  };

  chartOption: any;
  loading: boolean;
  barSelected: number = 0;
  count: number = 0;
  teamKey: number = 0;
  customerKey: number = 0;
  RoChartOption: any;
  roGraphData: any;

  constructor(
    private readonly dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  extClick() {
    this.RODetailsData.pending = 0;
    this.RODetailsData.enRoute = 0;
    this.RODetailsData.onSite = 0;
    this.RODetailsData.waitingEst = 0;
    this.RODetailsData.waitingClientApp = 0;
  }

  public showActiveWO(count, statusPrecedence): void {
    if (count > 0) {
      this.dialog.open(WoActivePopupComponent, {
        width: '70%',
        height: 'auto',
        maxHeight: '90%',
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-transparent-backdrop',
        data: { statusPrecedence: statusPrecedence, count: count }
      });
    }
  }

  chartClicked(event): void {
    if (event.componentIndex == 0 && event.seriesIndex == 0 && event.name == 'Pending/DIP') {
      this.count = this.RODetailsData.pending;
      this.barSelected = 1;
    }

    if (event.componentIndex == 0 && event.seriesIndex == 0 && event.name == 'En Route') {
      this.count = this.RODetailsData.enRoute;
      this.barSelected = 2;
    }

    if (event.componentIndex == 0 && event.seriesIndex == 0 && event.name == 'Onsite/Towing') {
      this.count = this.RODetailsData.onSite;
      this.barSelected = 3;
    }

    if (event.componentIndex == 0 && event.seriesIndex == 0 && event.name == 'Waiting Estimate') {
      this.count = this.RODetailsData.waitingEst;
      this.barSelected = 4;
    }

    if (event.componentIndex == 0 && event.seriesIndex == 0 && event.name == 'Customer Action Needed') {
      this.count = this.RODetailsData.waitingClientApp;
      this.barSelected = 5;
    }

    this.teamKey = 0;
    this.customerKey = 0;
    this.dialog.open(ShowWoPopupComponent, {
      width: '90%',
      height: 'auto',
      maxHeight: '90%',
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      data: { barSelected: this.barSelected }
    });
  }

  setRODetailsCounts() {
    this.loading = true;
    this.resetGraph();
    if (this.roDetailsCount) {
      this.roDetailsCount.forEach(element => {
        if (element.CodeKey === 1141 || element.CodeKey === 1623) {
          this.RODetailsData.pending = this.RODetailsData.pending + element.ROCount;
        } else if (element.CodeKey === 962) {
          this.RODetailsData.enRoute = this.RODetailsData.enRoute + element.ROCount;
        } else if (element.CodeKey === 963 || element.CodeKey === 964 || element.CodeKey === 1373 || element.CodeKey === 1374 || element.CodeKey === 1363) {
          this.RODetailsData.onSite = this.RODetailsData.onSite + element.ROCount;
        } else if (element.CodeKey === 1156 || element.CodeKey === 1155 || element.CodeKey === 1624) { // || element.CodeKey === 1157
          this.RODetailsData.waitingEst = this.RODetailsData.waitingEst + element.ROCount;
        } else {
          this.RODetailsData.waitingClientApp = this.RODetailsData.waitingClientApp + element.ROCount;
        }
      });
      this.roGraphData = [
        this.RODetailsData.pending,
        this.RODetailsData.enRoute,
        this.RODetailsData.onSite,
        this.RODetailsData.waitingEst,
        this.RODetailsData.waitingClientApp
      ];
      this.setROChart();
      this.loading = false;
    }
  }

  resetGraph() {
    this.roGraphData = [];
    this.RODetailsData.pending = 0;
    this.RODetailsData.enRoute = 0;
    this.RODetailsData.onSite = 0;
    this.RODetailsData.waitingEst = 0;
    this.RODetailsData.waitingClientApp = 0;
  }

  setROChart() {
    this.RoChartOption = {
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      yAxis: {
        type: 'value'
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          show: true,
          interval: 0,
          rotate: 25,
          margin: 10
        },
        data: ['Pending/DIP', 'En Route', 'Onsite/Towing', 'Waiting Estimate', 'Customer Action Needed']
      },
      series: [
        {
          name: 'Orange Stage',
          type: 'bar',
          stack: 'one',
          barWidth: 50,
          itemStyle: { color: 'orange' },
          label: {
            normal: {
              show: true,
              position: 'insideRight'
            }
          },
          data: [
            {
              value: this.roGraphData[0],
              itemStyle: { color: 'orange' },
            },
            {
              value: this.roGraphData[1],
              itemStyle: { color: 'orange' },
            },
            {
              value: this.roGraphData[2],
              itemStyle: { color: 'orange' },
            },
            {
              value: this.roGraphData[3],
              itemStyle: { color: 'orange' },
            },
            {
              value: this.roGraphData[4],
              itemStyle: { color: 'red' },
            }
          ],
        }
      ]
    };
  }

}
